import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Contactpage from '../../components/Contactpage/Contactpage'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Logo from '../../images/logo-2.svg'
import Phone from '../../images/telephone.svg'
// import CursorMaus from '../../components/CursorMaus/CursorMaus';
import LenisSmoothScroll from '../../components/lenissmoothscroll/LenisSmoothScroll';

const ContactPage =() => {
    return(
        <Fragment>
            <Navbar Logo={Logo} hclass={"wpo-site-header s3"} telephone={Phone} />
            <PageTitle pageTitle={'Contact Us'} pagesub={'Contact'}/> 
            <Contactpage/>
            <Footer/>
            <Scrollbar/>
            {/* <CursorMaus /> */}
            < LenisSmoothScroll />
        </Fragment>
    ) 
};
export default ContactPage;

